// assets/product-custom-property.js
import { Component } from '@theme/component';

/**
 * @typedef {object} ProductCustomPropertyRefs
 * @property {HTMLInputElement | HTMLTextAreaElement} textInput - The text input.
 * @property {HTMLElement} characterCount - The character count element.
 */

/**
 * A custom element that manages product custom properties
 * @extends Component<ProductCustomPropertyRefs>
 */
class ProductCustomProperty extends Component {
  connectedCallback() {
    super.connectedCallback();

    const checkbox = this.querySelector('input[type="checkbox"]');
    const messageField = this.querySelector('[data-gift-message-field]');
    const messageInput = this.querySelector('[data-gift-presentation-message]');
    if (!(checkbox instanceof HTMLInputElement) || !(messageInput instanceof HTMLTextAreaElement) || !messageField) return;

    const updateGiftMessage = () => {
      messageField.toggleAttribute('hidden', !checkbox.checked);
      messageInput.disabled = !checkbox.checked;
      if (!checkbox.checked) messageInput.value = '';
    };

    checkbox.addEventListener('change', updateGiftMessage);
    messageInput.addEventListener('input', () => {
      const counter = messageField.querySelector('.__character-label');
      if (counter) counter.textContent = `${messageInput.value.length}/160`;
    });
    updateGiftMessage();
  }

  handleInput() {
    this.#updateCharacterCount();
  }

  #updateCharacterCount() {
    const { characterCount, textInput } = this.refs;
    const currentLength = textInput.value.length;
    const maxLength = textInput.maxLength;

    const template = characterCount.getAttribute('data-template');
    if (!template) return;

    const updatedText = template.replace('[current]', currentLength.toString()).replace('[max]', maxLength.toString());

    characterCount.textContent = updatedText;
  }
}

customElements.define('product-custom-property-component', ProductCustomProperty);
